export interface Clock {
  now(): number;
}

export class FakeClock implements Clock {
  constructor(private current: number) {}
  now(): number {
    return this.current;
  }
  advance(ms: number): void {
    this.current += ms;
  }
}

export class SystemClock implements Clock {
  now(): number {
    return Date.now();
  }
}
